import { Component, OnDestroy } from '@angular/core'
import {
    closeCaseManagementDialog,
    closeManagementDialog$,
} from '../../shared/utils/case-management-dialog-utils'
import { filter, map, Subject, switchMap, takeUntil, tap } from 'rxjs'
import { Dialog, DialogRef } from '@angular/cdk/dialog'
import { GenericSingleInputDialogModel } from '../../shared/components/generic-single-input-dialog/generic-single-input-dialog.model'
import { GenericSingleInputDialogComponent } from '../../shared/components/generic-single-input-dialog/generic-single-input-dialog.component'
import { HttpErrorResponse } from '@angular/common/http'
import { ToasterService } from '../../shared/services/toaster.service'
import { UploadService } from '../../shared/services/upload.service'
import { DatasetBrowserApiService } from '../../shared/services/dataset-browser-api.service'
import { Store } from '@ngrx/store'
import { casesActions } from '../../state/cases/cases.actions'

@Component({
    selector: 'app-case-management-dialog',
    templateUrl: './case-management-dialog.component.html',
    styleUrls: ['./case-management-dialog.component.scss'],
})
export class CaseManagementDialogComponent implements OnDestroy {
    showUpload = false
    loading = false

    private readonly destroy$ = new Subject<void>()

    constructor(
        readonly dialogRef: DialogRef<void>,
        private readonly dialog: Dialog,
        private readonly toaster: ToasterService,
        private readonly uploader: UploadService,
        private readonly datasetBrowserApi: DatasetBrowserApiService,
        private readonly store: Store
    ) {
        closeManagementDialog$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.dialogRef.close()
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    closeDialog(): void {
        closeCaseManagementDialog()
    }

    createNewDataset(): void {
        const data: GenericSingleInputDialogModel = {
            title: 'Create new dataset',
            inputLabel: 'Dataset name',
        }
        const dialogRef = this.dialog.open<string>(GenericSingleInputDialogComponent, {
            data,
            autoFocus: 'first-tabbable',
        })
        dialogRef.closed
            .pipe(
                takeUntil(this.destroy$),
                filter((name: string | undefined): name is string => !!name),
                tap(_ => (this.loading = true)),
                switchMap(name =>
                    this.datasetBrowserApi.createDataset(name).pipe(
                        map(id => ({
                            id,
                            name,
                        }))
                    )
                )
            )
            .subscribe({
                next: ({ id, name }) => {
                    this.loading = false
                    this.openUnsubmittedDataset({ id, name })
                    this.store.dispatch(casesActions.creatingDatasetSucceeded())
                },
                error: (err: HttpErrorResponse) => {
                    this.loading = false
                    this.toaster.httpError(err, err.error?.message || 'Error creating new dataset')
                },
            })
    }

    openUnsubmittedDataset({ id, name }: { id: number; name: string }): void {
        this.uploader.setUploadId(id, name)
        this.showUpload = true
    }
}
